import { useUserEventLogger } from '@repo/tracking-service';
import { List } from '@zenterprise-inc/ui';

import FillRegisterCert from '@/assets/illust-icons/fill-register-cert.svg';
import { useInvalidOSDialog } from '@/components/tax-refund/common/hooks/use-invalid-os-dialog';
import useDetectOs from '@/lib/hooks/use-detect-os';

const DecisionNPKISection = ({ handleNPKIStep }: { handleNPKIStep: () => void }) => {
  const detectOS = useDetectOs();
  const { sendClickEvent } = useUserEventLogger();
  const { showInvalidOSDialog } = useInvalidOSDialog();

  const handleClick = () => {
    sendClickEvent('indis-decision_selectauth_commoncert');

    if (detectOS === 'windows') {
      handleNPKIStep();
    } else {
      showInvalidOSDialog();
    }
  };

  return (
    <>
      <List.Basic
        left={<FillRegisterCert width={36} height={36} />}
        title={{ text: '공동인증서로 확인하기', titleStyle: 'headline-18' }}
        subText={{ text: '홈택스에 등록된 개인 인증서로 확인해요.' }}
        listIcon
        className="page-padding cursor-pointer"
        onClick={handleClick}
      />
    </>
  );
};

export default DecisionNPKISection;
